import type { MouseEventHandler, ReactNode } from 'react';
import cn from '@/utils/merge-class-names';

interface Props {
  label: ReactNode;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

export default function MenuItem({ disabled = false, label, className, onClick }: Props) {
  return (
    <button
      type='button'
      disabled={disabled}
      className={cn('btn btn-ghost z-10 rounded-none', className)}
      onClick={onClick}>
      {label}
    </button>
  );
}
